import { Button, Card, DatePicker, Modal, notification, Select, Upload } from "antd"
import Form from "antd/es/form/Form"
import Input from "antd/es/input/Input"
import Title from "antd/es/typography/Title"
import { CreateTool, } from "../../../api/AdminService"
import { useNavigate } from "react-router-dom"
import { PlusOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Option } from "antd/es/mentions"
import { useState } from "react"
const AdminAddTool = ({ open, onClose, onSuccess }) => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const onFinish = async (values) => {
        try {
            const imageFile = values.image?.[0]?.originFileObj;
            console.log('imageFile : ', imageFile)
            setLoading(true);
            CreateTool(
                values.name,
                values.totalTool,
                values.status,
                imageFile
            ).then((res) => {
                console.log(res);
                notification.success({
                    message: "Created Tool Successfully"
                });
                setLoading(false);
                onSuccess();
                onClose();
            });
        } catch (err) {
            console.log(err.response?.data?.message);
            notification.error({
                message: err.response?.data?.message || "Error creating account"
            });
            setLoading(false)
        }
    }


    return (
        // <div>AdminAddAccount</div>
        // <div style={{ minHeight: '96.5vh', Width: '100%' }}
        // >
        //     <Button
        //         icon={<ArrowLeftOutlined />}
        //         onClick={() => navigate(-1)}
        //         style={{ marginBottom: 16 }}
        //     >
        //         Go Back
        //     </Button>
        //     <div style={{ maxWidth: 600, margin: 'auto', padding: '24' }}>
        <Modal
            open={open}
            title="Create Tool"
            onCancel={onClose}
            footer={[]}
        >
            <Form
                onFinish={onFinish}
                name="wrap"
                labelAlign="left"
                labelWrap
                labelCol={{ flex: '150px' }}
            >

                <Form.Item
                    name="image"
                    label="Image"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                        if (Array.isArray(e)) {
                            return e;
                        }
                        return e?.fileList;
                    }}
                >
                    <Upload
                        listType="picture-card"
                        maxCount={1}
                        beforeUpload={() => false} // Prevent auto upload
                        accept="image/*"
                    >
                        <div>
                            <PlusOutlined />
                            <div style={{ marginTop: 8 }}>Upload</div>
                        </div>
                    </Upload>
                </Form.Item>
                <Form.Item name={"name"} label="Name" rules={[{ required: true, message: 'Requiring name' }]}>
                    <Input
                        placeholder="Input Name"
                    />
                </Form.Item>
                <Form.Item name={"totalTool"} label="Total Tool" rules={[{ required: true, message: 'Requiring total tool' }]}>
                    <Input
                        placeholder="Input Total Tool"
                    />
                </Form.Item>

                <Form.Item >
                    <Button block type="primary" htmlType="submit" loading={loading}>
                        {loading ? "Loading" : "Save"}
                    </Button>
                </Form.Item>

            </Form>
        </Modal>

        //     </div>
        // </div>
    )

}
export default AdminAddTool
